// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--GLr80","loader":"dd31006766--loader--322vl"};